import comp from "./AsyncRouteLoading";
export default comp;
